<template>
  <v-container class="fill-height">
    <v-row v-if="showRedirectionMessage">
      <v-card class="mx-auto px-6 py-8">
        <p class="text-h5">Congratulations</p>
        <p class="text-subtitle-1">Your account successfully confirmed, you will be redirected in {{ timer }}.</p>
        <p class="text-subtitle-2">Please click this
          <router-link :to="signRedirectionLink">link</router-link>
          for manual redirection.
        </p>
      </v-card>
    </v-row>
    <v-row v-if="!confirmParametersIsset">
      <v-card class="mx-auto px-6 py-8">
        <p class="text-h5">Error</p>
        <p class="text-subtitle-1">Confirm parameters don't set. Please verify reset link or contact mainroad.trade
          administrator.</p>
      </v-card>
    </v-row>
    <v-row v-if="errorMessage !== null">
      <v-card class="mx-auto px-6 py-8">
        <p class="text-h5">Error</p>
        <p class="text-subtitle-1">{{ errorMessage }}</p>
      </v-card>
    </v-row>
    <v-overlay
        v-model="loading"
        :persistent="loading"
        :contained="true"
        class="align-center justify-center"
    >
      <v-progress-circular
          indeterminate
          size="64"
      />
    </v-overlay>
  </v-container>
</template>

<script>
import {router} from "@/router";
import {auth} from "@/common/auth";
import {readonly} from "vue";
import {messages} from "@/common/enum/messages";

export default {
  name: 'ConfirmView',
  props: {
    redirectionLink: {
      default: 'sign-in',
      type: String
    }
  },
  data() {
    return {
      signRedirectionLink: readonly({
        name: 'sign-in'
      }),
      homeRedirectionLink: readonly({
        name: 'home'
      }),
      id: null,
      hash: null,
      timer: 5,
      loading: false,
      showRedirectionMessage: false,
      errorMessage: null
    }
  },
  mounted() {
    if (auth.isAuthorized()) {
      router.push(this.homeRedirectionLink)
    }

    this.id = this.$route.query.id
    this.hash = this.$route.query.hash
    if (this.confirmParametersIsset){
      this.confirmUser()
    }
  },
  methods: {
    confirmUser() {
      this.loading = true
      auth.confirmUser(this.id, this.hash, (responseMessage) => {
        this.loading = false
        if (responseMessage !== null) {
          this.errorMessage = responseMessage.length === 0 ? messages.en.confirm_view.fatal_error : responseMessage
          return
        }

        this.showRedirectionMessage = true
        this.countdownTimer()
      })
    },
    countdownTimer() {
      if (this.timer === 0) {
        router.push(this.signRedirectionLink)
        return
      }

      setTimeout(() => {
        this.timer -= 1
        this.countdownTimer()
      }, 1000)
    }
  },
  computed: {
    confirmParametersIsset() {
      return this.id && this.hash
    }
  },
}
</script>

<style scoped>

</style>